import { useMemo } from 'react';
import { CarCardType } from '~/data/types/car/cars';

export const useIsCarZeroKm = (car: CarCardType | null) => {
  return useMemo(
    () => car?.familyCarZoneId.includes('Chassis') ?? false,
    [car],
  );
};
